import { PTmbDetailActivity } from "libs/raas-ui-react-components/src/components";
import { useEffect, useState } from "react";
import {
	getIdTmbSelect,
	removeTMBSummaryDetail,
	setTmbActivitySelected,
} from "services/user/user.session.service";
import { getDetailTmb, getLanguageTMB } from "./TmbDetailActivity.service";
import { IDetailTmb } from "./TmbDetailActivity.model";
import { useTranslation } from "react-i18next";
import useSession from "hooks/useSession";
import PrivatePagesWrapper from "components/PrivatePagesWrapper/PrivatePagesWrapper";
import { useNavigate } from "react-router-dom";
import { literalDetailTmb } from "../TmbNightBusFlow/TmbNightBusFlow.util";
declare const window: any;

export const TmbDetailActivity = () => {
	const { cardTMB, logged } = useSession();
	const [idDetail, setIdDetail] = useState(getIdTmbSelect());
	const [detailDataTmb, setDetailDataTmb] = useState<IDetailTmb[]>();
	const [activitySelectedIndex, setActivitySelectedIndex] = useState(0);

	const [t, i18n] = useTranslation("tmbPages");
	const [callSucess, setCallSucess] = useState(false);
	const navigate = useNavigate();

	let lenguage = "";

	const literalsDetail: any = literalDetailTmb(t)

	useEffect(() => {
		if (sessionStorage.getItem("raas-language") != lenguage) {
			lenguage = sessionStorage.getItem("raas-language") as any;
			getTmbActivities(getLanguageTMB(i18n.language));
		}
	}, [t]);

	useEffect(() => {
		setCallSucess(false);
		getTmbActivities(getLanguageTMB(i18n.language));
		//}, window.sessionStorage["raas-trip-mock"])
	}, [idDetail]);

	//Funcion que recoge la activida seleccionada TENDREMOS QUE SABER QUE TIPO DE ACTIVIDAD PARA EL FLUJO DE COMPRA
	//GUARDAR EN SESSION DEL NAVEGADOR O EN GLOBAL CONTEX
	const detailTmb = (e: any) => {
		let activityInfo = {
			termsAndConditions:"",
			privacyPolicy:"",
			title: "",
			price: {},
            contextType: "",
            provider: "",
			description:{},
			url:"",
			catalogueItemId:""
		};
		if (detailDataTmb) {
			activityInfo = {
				termsAndConditions:cardTMB?.termsAndConditions,
				privacyPolicy:cardTMB?.privacyPolicy,
				title: detailDataTmb[activitySelectedIndex]?.name,
				price: detailDataTmb[activitySelectedIndex]?.price,
                contextType: detailDataTmb[activitySelectedIndex]?.contextType,
                provider: detailDataTmb[activitySelectedIndex]?.provider,
				description:detailDataTmb[activitySelectedIndex]?.description,
				url:detailDataTmb[activitySelectedIndex]?.image,
				catalogueItemId:detailDataTmb[activitySelectedIndex]?.catalogueItemId

			};
		}
		setTmbActivitySelected(activityInfo);
		//removeTMBSummaryDetail(); 

		//navigate("/tmb-night-bus-flow");

        // v1
	
		// switch (idDetail) {
		// 	case "montjuic-cable-car":
		// 		window.open(`https://www.holabarcelona.com/es/tickets/teleferico-montjuic-barcelona`);
		// 		navigate("/tmb-normal-flow");
		// 		break
		// 	case "holabarcelona-travel-card":
		// 		window.open(`https://www.holabarcelona.com/es/tickets/hola-bcn-barcelona-travel-card`);
		// 		navigate("/tmb-normal-flow");
		// 		break
		// 	case "barcelona-bus-turistic":
		// 	case "barcelona-bus-turist":
		// 		window.open(`https://www.holabarcelona.com/es/tickets/barcelona-bus-turistico`);
		// 		navigate("/tmb-normal-flow");
		// 		break;

		// 	default:
		// 		navigate("/tmb-night-bus-flow");
		// 		break;
		// }
       
		switch (idDetail) {           
			case "montjuic-cable-car":		
			case "teleférico-de-montjuïc":		
			case "holabarcelona-travel-card":
			case "barcelona-bus-turist":
			case "bus-turístico-barcelona":
				navigate("/tmb-normal-flow");
				break;

			default:
				navigate("/tmb-night-bus-flow");
				break;
		}
	};

	const refreshList = (e: any) => {
		getDetailTmb(
			logged,
			idDetail,
			(response: IDetailTmb[]) => {
				setDetailDataTmb(response);
			},
			(err: any) => {},
			getLanguageTMB(i18n.language),
			"normal"
		);
		//}, window.sessionStorage["raas-trip-mock"])
	};

	const getTmbActivities = (lenguage: any) => {
		getDetailTmb(
			logged,
			idDetail,
			(response: IDetailTmb[]) => {
				setDetailDataTmb(response);
				setCallSucess(true);
			},
			(err: any) => {
				setCallSucess(true);
			},
			getLanguageTMB(i18n.language),
			"normal"
		);
	};

	const activitySelected = (e: any) => {
		setActivitySelectedIndex(e.detail);
	};

	return (
		<>
			{callSucess && (
				<>
					<PTmbDetailActivity
						onBuyTmb={detailTmb}
						onTryAgain={refreshList}
						onActivitySelected={activitySelected}
						literalsDetail={literalsDetail}
						//Simular error con el null
						//activitiesList={null}
						activitiesList={detailDataTmb}
					/>
					<PrivatePagesWrapper></PrivatePagesWrapper>
				</>
			)}
		</>
	);
};
